import { __decorate } from "tslib";
import Component from "vue-class-component";
import ReactiveComponent from "../components/ReactiveComponent";
import Task from "@/services/task";
import TemplateContent from "@/components/template/TemplateContent.vue";
import ProgrammingBoard from "@/components/ProgrammingBoard.vue";
import { Order_By } from "@/generated/graphql";
import { Watch } from "vue-property-decorator";
import { addWeeks, getISOWeek, getISOYear, setDay, setISOWeek, setISOYear, subWeeks } from "date-fns";
import ProgressButton from "@/components/ProgressButton.vue";
import * as _ from "lodash";
import Formatter from "../utils/formatter";
class TrainingData {
    constructor(id, day, week, year, content, extra_strength, extra_gym, extra_aerobic, extra_double, board) {
        this.id = id;
        this.day = day;
        this.week = week;
        this.year = year;
        this.content = content;
        this.extra_strength = extra_strength;
        this.extra_gym = extra_gym;
        this.extra_aerobic = extra_aerobic;
        this.extra_double = extra_double;
        this.board = board;
    }
}
let Programming = class Programming extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.trainings = new Array();
        this.trainingsTask = Task.idle();
        this.boardsTask = Task.idle();
        this.trainingsQueries = new Map();
        this.day = -1;
        this.week = -1;
        this.year = -1;
        // private dateInRange(date: Date, startDate: Date, endDate: Date): boolean {
        //   // return isAfter(it.date, this.startDate) || isEqual(it.date, this.startDate) || isEqual(it.date, this.endDate) || isBefore(it.date, this.endDate)
        //   return isWithinRange(date, startDate, endDate)
        // }
    }
    created() {
        this.fetchBoards();
    }
    onUpdateQuery() {
        let now = new Date();
        let year = null;
        if (this.$route.params.year != null) {
            year = Number(this.$route.params.year);
        }
        this.year =
            year != null && Number.isInteger(year) ? year : getISOYear(now);
        let week = null;
        if (this.$route.params.week != null) {
            week = Number(this.$route.params.week);
        }
        this.week =
            week != null && Number.isInteger(week) ? week : getISOWeek(now);
        let day = null;
        if (this.$route.params.day != null) {
            day = Number(this.$route.params.day);
        }
        this.day =
            day != null && Number.isInteger(day) && day >= 1 && day <= 7 ? day : 1;
        // let date = new Date(year, , 0, 0, 0, 0)
        //
        // this.currentWeek = getISOWeek(date)
        // this.currentYear = getISOYear(date)
        // this.startDate = startOfWeek(date, {weekStartsOn: 1})
        // this.endDate = endOfWeek(date, {weekStartsOn: 1})
        this.fetchTrainings();
    }
    nextWeekYear() {
        let date = new Date();
        setDay(date, this.day, { weekStartsOn: 1 });
        date = setISOYear(date, this.year);
        date = setISOWeek(date, this.week);
        date = addWeeks(date, 1);
        return {
            day: this.day,
            week: getISOWeek(date),
            year: getISOYear(date)
        };
    }
    prevWeekYear() {
        let date = new Date();
        setDay(date, this.day, { weekStartsOn: 1 });
        date = setISOYear(date, this.year);
        date = setISOWeek(date, this.week);
        date = subWeeks(date, 1);
        return {
            day: this.day,
            week: getISOWeek(date),
            year: getISOYear(date)
        };
    }
    fetchBoards() {
        this.subscribeQuery({
            tag: "boards",
            options: {
                query: require("@/apollo/queries/allBoards.graphql"),
                variables: { orderByLevel: Order_By.Desc }
            },
            onTask: task => {
                this.boardsTask = task;
                if (task.isSuccessful) {
                    this.allBoardsQuery = task.data;
                    this.updateTrainings(this.week, this.year);
                }
            }
        });
    }
    fetchTrainings() {
        const weekTag = this.weekTag(this.week, this.year);
        if (this.trainingsQueries.has(weekTag)) {
            if (this.trainings.filter(it => this.isSameWeek(it, this.week, this.year))
                .length > 0) {
                console.log(`Trainings already loaded for week ${weekTag}`);
            }
            else {
                // Query completed but callback did not run
                this.updateTrainings(this.week, this.year);
            }
            return;
        }
        console.log(`Fetch trainings for week ${weekTag}`);
        // const year = this.year
        // const week = this.week
        // const startDate = this.startDate
        // const endDate = this.endDate
        // const week = this.week
        const currentWeek = this.week;
        const currentYear = this.year;
        this.subscribeQuery({
            tag: `trainings`,
            options: {
                query: require("@/apollo/queries/programming.graphql"),
                variables: { week: currentWeek, year: currentYear }
            },
            onTask: task => {
                this.trainingsTask = task;
                if (task.isSuccessful) {
                    // console.log(task.data!.training)
                    this.trainingsQueries.set(weekTag, task.data);
                    this.updateTrainings(currentWeek, currentYear);
                }
            }
        });
    }
    updateTrainings(week, year) {
        const weekTag = this.weekTag(week, year);
        if (this.allBoardsQuery == null || !this.trainingsQueries.has(weekTag)) {
            console.log(`Cannot update trainings for week ${weekTag}, not ready yet`);
            return;
        }
        console.log(`Update trainings for week ${weekTag}`);
        _.remove(this.trainings, it => this.isSameWeek(it, week, year));
        const trainingsQuery = this.trainingsQueries.get(weekTag);
        for (let board of this.allBoardsQuery.board) {
            // const daysOff: Array<number> = StringUtils.isNotBlank(board.days_off) ? _.uniq(_.split(board.days_off, ',').map(it => Number(it)).filter(it => Number.isInteger(it))) : []
            // console.log(`Days off for board ${board.level}: ${daysOff}`)
            // let daysOffPush = 0
            for (let day of _.range(1, 8)) {
                // while (daysOff.indexOf(trainingDay + daysOffPush) >= 0 && trainingDay + daysOffPush < 8) {
                //   daysOffPush += 1
                // }
                //
                // const day = trainingDay + daysOffPush
                // if (day > 7) {
                //   break
                // }
                //
                // const date = addDays(startDate, day - 1)
                // console.log(`Training day ${trainingDay} is ${format(date, 'dddd')}`)
                let training;
                const existingTraining = trainingsQuery.training_by_week.find(it => it.board.id === board.id && it.day == day);
                if (existingTraining != undefined) {
                    training = new TrainingData(existingTraining.id, existingTraining.day, existingTraining.week, existingTraining.year, Formatter.formatTrainingContent(existingTraining), "", "", "", "", board);
                }
                else {
                    training = new TrainingData(-1, day, week, year, "", "", "", "", "", board);
                }
                this.trainings.push(training);
            }
        }
        console.log(`Update trainings for week ${weekTag} - done`);
    }
    get trainingsPerRows() {
        const trainings = this.trainings.filter(it => it.year == this.year && it.week == this.week && it.day == this.day);
        trainings.sort((a, b) => b.board.level - a.board.level);
        // console.log(`Trainings per row for date ${date}: ${trainings.length}`)
        const trainingsPerRow = new Array();
        for (const [index, training] of trainings.entries()) {
            if (index % 2 == 0) {
                trainingsPerRow.push([]);
            }
            trainingsPerRow[trainingsPerRow.length - 1].push(training);
        }
        return trainingsPerRow;
    }
    // private dateRangeTag(startDate: Date, endDate: Date): string {
    //   return `${getDate(startDate)}/${getMonth(startDate)} - ${getDate(endDate)}/${getMonth(endDate)}`
    // }
    weekTag(week, year) {
        return `${week}-${year}`;
    }
    isSameWeek(training, week, year) {
        return training.week == week && training.year == year;
    }
};
__decorate([
    Watch("$route.query", { immediate: true })
], Programming.prototype, "onUpdateQuery", null);
Programming = __decorate([
    Component({
        components: { ProgressButton, TemplateContent, ProgrammingBoard }
    })
], Programming);
export default Programming;
